import { removeToken } from './token';
import { removeCompassAppToken } from './compass-app-token';

export default function logoutClear() {
  removeToken();
  removeCompassAppToken();
  delete window.Glide.SESSION_CHANNEL;
}
